/* cg-beweging — de bewegingskit van het basisthema.
   Eén script voor beweging en interactie in alle secties, zodat de bouwer niet
   per sectie eigen JavaScript schrijft. Gegroeid uit de twee winkels die met de
   hand naar hun model werden gebouwd (Evia naar tryhaloring.com, Meuse naar
   smooche.com, oktober 2026). Het werkt met attributen in de markup:

     data-cg-reveal="up|fade|scale|left|right|clip|letters|draw" (+ data-cg-delay="ms")
         komt binnen als 12% in beeld is. "letters": de tekst valt letter voor
         letter in. "draw": tekent een SVG-lijn (zie .cg-cirkel).
     data-cg-count="1.000" | "4,8" | "€0" | "98%"
         telt op van nul als het in beeld komt.
     data-cg-scene
         lange sectie met een sticky binnenkant: zet --cg-p van 0 (bovenkant
         raakt de bovenkant van het scherm) tot 1 (onderkant raakt onderkant).
         Gebruik --cg-p in de CSS van de sectie (transform, opacity, …).
     data-cg-progress
         zet --cg-q van 0 (komt onder binnen) tot 1 (gaat boven weg).
     data-cg-parallax="0.12" (+ data-cg-rotate="8")
         schuift (en draait) mee met de scroll, gemeten aan de ouder.
     data-cg-carousel met [data-cg-track] (scroll-snap), [data-cg-prev],
         [data-cg-next], [data-cg-dots], [data-cg-thumb="i"]; data-cg-center
         = het middelste kind telt; data-cg-start="2" = beginnen bij kind 2.
     data-cg-slides="6000" met [data-cg-slide]-kinderen en een [data-cg-pauze]
         knop: dia's die in elkaar overvloeien, met een pauzeknop.
     data-cg-ticker="5000" met [data-cg-tick]-kinderen: berichten die wisselen.
     data-cg-countdown="7" met [data-cg-time] en [data-cg-bar]: een klok die
         elke 7 uur rondloopt; de balk loopt leeg met de tijd die over is.
     details[data-cg-faq] met [data-cg-answer]: zacht open en dicht.
     .cg-cirkel op een kop: om het cursieve woord (<em>) komt een getekende lus.
     data-cg-voorna: een voor-en-na-schuif. Daarin een beeld "na" (onder), een
         .cg-voorna__voor met het beeld "voor" (boven, afgesneden), een
         <input type="range" class="cg-voorna__schuif"> (sleepbaar, ook met het
         toetsenbord) en een .cg-voorna__greep. Zet --cg-voorna (0-100%).

   Wie minder beweging wil (prefers-reduced-motion), krijgt alles meteen en
   stil. Zonder JavaScript is alles zichtbaar: de verborgen beginstand hangt aan
   html.cg-motion, en die klasse zet een klein script in de head (met een
   vangnet van 4 s) en dit script. */
(function () {
  'use strict';
  if (window.__cgBeweging) { window.__cgBeweging.scan(document); return; }

  var d = document, w = window, root = d.documentElement;
  var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false, addEventListener: function () {} };
  var stil = function () { return mq.matches; };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var each = function (lijst, fn) { Array.prototype.forEach.call(lijst || [], fn); };
  var num = function (el, naam, standaard) { var v = parseFloat(el.getAttribute(naam)); return isNaN(v) ? standaard : v; };

  /* ═══ 1. BINNENKOMEN ═══════════════════════════════════════════════════ */
  var revIO = null;
  function laatZien(el) {
    if (el.__cgIn) return;
    el.__cgIn = true;
    if (revIO) revIO.unobserve(el);
    var ms = stil() ? 0 : num(el, 'data-cg-delay', 0);
    if (ms) el.style.transitionDelay = ms + 'ms';
    el.classList.add('is-in');
    setTimeout(function () { el.classList.add('is-done'); if (ms) el.style.transitionDelay = ''; }, ms + 1400);
  }
  function bijBinnenkomen(entries) {
    each(entries, function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.12) laatZien(e.target);
      else if (!e.isIntersecting && e.boundingClientRect.bottom < 0) laatZien(e.target);
      else if (e.isIntersecting && e.boundingClientRect.height * 0.12 > w.innerHeight) laatZien(e.target);
    });
  }
  /* "letters": de tekst in losse letters met een index (--i), één keer. */
  function letters(el) {
    if (el.__cgLetters) return; el.__cgLetters = true;
    var tekst = el.textContent;
    el.setAttribute('aria-label', tekst.trim());
    el.textContent = '';
    var i = 0;
    tekst.split(/(\s+)/).forEach(function (deel) {
      if (!deel) return;
      if (/^\s+$/.test(deel)) { el.appendChild(d.createTextNode(' ')); return; }
      var woord = d.createElement('span');
      woord.className = 'cg-woord'; woord.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(deel, function (c) {
        var s = d.createElement('span');
        s.className = 'cg-letter'; s.style.setProperty('--i', i++); s.textContent = c;
        woord.appendChild(s);
      });
      el.appendChild(woord);
    });
  }

  /* ═══ 2. MEELOPEN MET DE SCROLL ═════════════════════════════════════════
     Scènes worden elke frame voor alle lopers uitgerekend: een scène die je in
     één sprong voorbij scrolt, blijft anders op een tussenstand staan.
     Parallax alleen voor wat in de buurt van het scherm is, en gemeten aan de
     ouder: de eigen beweging zou de meting vervuilen. */
  var lopers = [], actief = new Set(), raf = 0, actIO = null;
  function plan() { if (!raf) raf = requestAnimationFrame(beeld); }
  function beeld() {
    raf = 0;
    if (stil()) return;
    var vh = w.innerHeight, vc = vh / 2;
    lopers.forEach(function (r) {
      if (!r.el.isConnected) return;
      var parallax = (r.par || r.rot) && actief.has(r);
      if (!r.scene && !r.prog && !parallax) return;
      var b = (parallax || r.prog ? r.meet : r.el).getBoundingClientRect();
      if (r.scene) {
        var bs = r.meet === r.el ? b : r.el.getBoundingClientRect();
        var lengte = bs.height - vh;
        var p = lengte > 0 ? clamp(-bs.top / lengte, 0, 1) : (bs.top <= 0 ? 1 : 0);
        var s = p.toFixed(4);
        if (s !== r.sv) { r.el.style.setProperty('--cg-p', s); r.sv = s; }
      }
      if (r.prog || parallax) {
        var midden = (b.top + b.bottom) / 2;
        var q = clamp((vc - midden) / (vc + b.height / 2), -1, 1);
        if (r.prog) { var qs = ((q + 1) / 2).toFixed(4); if (qs !== r.qv) { r.el.style.setProperty('--cg-q', qs); r.qv = qs; } }
        if (parallax) {
          var y = Math.round((vc - midden) * r.par * 100) / 100;
          var t = 'translate3d(0,' + y + 'px,0)' + (r.rot ? ' rotate(' + (q * r.rot).toFixed(2) + 'deg)' : '');
          if (t !== r.tf) { r.el.style.transform = t; r.tf = t; }
        }
      }
    });
  }
  function bijActief(entries) {
    each(entries, function (e) {
      var r = e.target.__cgRun;
      if (!r) return;
      if (e.isIntersecting) actief.add(r); else actief.delete(r);
    });
    plan();
  }

  /* ═══ 3. OPTELLEN ═══════════════════════════════════════════════════════ */
  var telIO = null;
  var TEL = /^(\D{0,3}?)(\d{1,3}(?:\.\d{3})+|\d+)([.,]\d+)?(\D{0,12})$/;
  function delen(ruw) {
    var m = TEL.exec(String(ruw).trim());
    if (!m) return null;
    var duizend = /\./.test(m[2]);
    var heel = m[2].replace(/\./g, '');
    var dec = m[3] ? m[3].length - 1 : 0;
    return { voor: m[1] || '', na: m[4] || '', sep: m[3] ? m[3][0] : '', dec: dec, duizend: duizend, doel: parseFloat(heel + (m[3] ? '.' + m[3].slice(1) : '')) };
  }
  function schrijf(p, v) {
    var t = v.toFixed(p.dec), heel = t.split('.')[0], rest = t.split('.')[1];
    if (p.duizend) heel = heel.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return p.voor + heel + (rest ? p.sep + rest : '') + p.na;
  }
  function telOp(el) {
    var ruw = el.getAttribute('data-cg-count') || el.textContent;
    var p = delen(ruw);
    if (!p || !(p.doel > 0)) { el.textContent = ruw; return; }
    var start = null, duur = num(el, 'data-cg-duur', 1500);
    var stap = function (ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duur), e = 1 - Math.pow(1 - t, 4);
      el.textContent = schrijf(p, p.doel * e);
      if (t < 1) requestAnimationFrame(stap); else el.textContent = ruw;
    };
    setTimeout(function () { requestAnimationFrame(stap); }, num(el, 'data-cg-delay', 0) + 100);
  }

  /* ═══ 4. CARROUSELS (en de galerij met duimen) ══════════════════════════ */
  function carrousel(c) {
    if (c.__cg) return; c.__cg = true;
    var track = c.querySelector('[data-cg-track]');
    if (!track) return;
    var kids = function () { return Array.prototype.filter.call(track.children, function (k) { return k.offsetParent !== null; }); };
    var dots = c.querySelector('[data-cg-dots]');
    var duimen = c.querySelectorAll('[data-cg-thumb]');
    var midden = c.hasAttribute('data-cg-center');
    var huidig = -1;
    var padding = function () { var n = parseFloat(getComputedStyle(track).scrollPaddingLeft); return isFinite(n) ? n : 0; };
    var tekenDots = function () {
      if (!dots) return;
      var n = kids().length;
      if (dots.children.length === n) return;
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = d.createElement('button');
        b.type = 'button'; b.className = 'cg-dot'; b.setAttribute('aria-label', 'Ga naar ' + (i + 1));
        (function (j) { b.addEventListener('click', function () { naar(j); }); })(i);
        dots.appendChild(b);
      }
    };
    var index = function () {
      var lijst = kids(), tr = track.getBoundingClientRect();
      var ref = midden ? tr.left + tr.width / 2 : tr.left + padding();
      var best = 0, afstand = Infinity;
      lijst.forEach(function (k, i) {
        var r = k.getBoundingClientRect();
        var a = Math.abs((midden ? r.left + r.width / 2 : r.left) - ref);
        if (a < afstand) { afstand = a; best = i; }
      });
      return best;
    };
    var naar = function (i, gedrag) {
      var lijst = kids(); if (!lijst.length) return;
      i = clamp(i, 0, lijst.length - 1);
      var tr = track.getBoundingClientRect(), r = lijst[i].getBoundingClientRect();
      var doel = midden ? track.scrollLeft + (r.left + r.width / 2) - (tr.left + tr.width / 2) : track.scrollLeft + r.left - tr.left - padding();
      track.scrollTo({ left: doel, behavior: gedrag || (stil() ? 'auto' : 'smooth') });
    };
    var bij = function () {
      var i = index(), lijst = kids();
      var prev = c.querySelector('[data-cg-prev]'), next = c.querySelector('[data-cg-next]');
      if (prev) prev.disabled = midden ? i <= 0 : track.scrollLeft <= 4;
      if (next) next.disabled = midden ? i >= lijst.length - 1 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (i === huidig) return;
      huidig = i;
      lijst.forEach(function (k, j) { k.classList.toggle('is-current', j === i); });
      if (dots) each(dots.children, function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      each(duimen, function (t) {
        var aan = parseInt(t.getAttribute('data-cg-thumb'), 10) === i;
        t.classList.toggle('is-active', aan); t.setAttribute('aria-current', aan ? 'true' : 'false');
      });
      c.dispatchEvent(new CustomEvent('cg:slide', { detail: { index: i } }));
    };
    var t = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(bij); }, { passive: true });
    each(c.querySelectorAll('[data-cg-prev]'), function (b) { b.addEventListener('click', function () { naar((huidig < 0 ? index() : huidig) - 1); }); });
    each(c.querySelectorAll('[data-cg-next]'), function (b) { b.addEventListener('click', function () { naar((huidig < 0 ? index() : huidig) + 1); }); });
    each(duimen, function (b) { b.addEventListener('click', function (e) { e.preventDefault(); naar(parseInt(b.getAttribute('data-cg-thumb'), 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); naar(huidig + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); naar(huidig - 1); }
    });
    c.__cgNaar = naar;
    tekenDots();
    var start = parseInt(c.getAttribute('data-cg-start'), 10);
    if (!isNaN(start) && start > 0) requestAnimationFrame(function () { naar(start, 'instant'); requestAnimationFrame(bij); });
    w.addEventListener('resize', function () { tekenDots(); huidig = -1; bij(); }, { passive: true });
    bij();
  }

  /* ═══ 5. DIA'S DIE OVERVLOEIEN ══════════════════════════════════════════ */
  function slides(el) {
    if (el.__cg) return; el.__cg = true;
    var lijst = el.querySelectorAll('[data-cg-slide]');
    var knop = el.querySelector('[data-cg-pauze]');
    if (lijst.length < 2) { if (knop) knop.hidden = true; return; }
    var i = 0, gepauzeerd = false, timer = 0, ms = num(el, 'data-cg-slides', 6000);
    var toon = function (n) {
      lijst[i].classList.remove('is-current'); lijst[i].setAttribute('aria-hidden', 'true'); lijst[i].inert = true;
      i = (n + lijst.length) % lijst.length;
      lijst[i].classList.add('is-current'); lijst[i].removeAttribute('aria-hidden'); lijst[i].inert = false;
    };
    each(lijst, function (s, j) { s.classList.toggle('is-current', j === 0); s.inert = j !== 0; if (j) s.setAttribute('aria-hidden', 'true'); });
    var stop = function () { clearInterval(timer); timer = 0; };
    var start = function () {
      stop();
      if (gepauzeerd || stil() || d.hidden) return;
      timer = setInterval(function () { if (!el.contains(d.activeElement)) toon(i + 1); }, ms);
    };
    if (knop) {
      knop.hidden = false;
      knop.addEventListener('click', function () {
        gepauzeerd = !gepauzeerd;
        knop.setAttribute('aria-pressed', gepauzeerd ? 'true' : 'false');
        knop.setAttribute('aria-label', gepauzeerd ? (knop.getAttribute('data-speel') || 'Afspelen') : (knop.getAttribute('data-pauzeer') || 'Pauzeren'));
        knop.classList.toggle('is-paused', gepauzeerd);
        start();
      });
    }
    d.addEventListener('visibilitychange', start);
    el.__cgStop = stop;
    start();
  }

  /* ═══ 6. WISSELENDE BERICHTEN ═══════════════════════════════════════════ */
  function ticker(el) {
    if (el.__cg) return; el.__cg = true;
    var lijst = el.querySelectorAll('[data-cg-tick]');
    if (lijst.length < 2) return;
    var i = 0, pauze = false;
    each(lijst, function (t, j) { t.classList.toggle('is-current', j === 0); t.setAttribute('aria-hidden', j === 0 ? 'false' : 'true'); });
    el.addEventListener('mouseenter', function () { pauze = true; });
    el.addEventListener('mouseleave', function () { pauze = false; });
    var t = setInterval(function () {
      if (pauze || d.hidden || el.contains(d.activeElement) || stil()) return;
      lijst[i].classList.remove('is-current'); lijst[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % lijst.length;
      lijst[i].classList.add('is-current'); lijst[i].setAttribute('aria-hidden', 'false');
    }, num(el, 'data-cg-ticker', 5000));
    el.__cgStop = function () { clearInterval(t); };
  }

  /* ═══ 7. DE AFTELKLOK ═══════════════════════════════════════════════════
     Loopt elke N uur rond. De balk loopt leeg met de tijd die over is: geen
     verzonnen "89% verkocht", wel hoeveel tijd de aanbieding nog heeft. */
  function klok(el) {
    if (el.__cg) return; el.__cg = true;
    var uren = num(el, 'data-cg-countdown', 7), tijd = el.querySelector('[data-cg-time]') || (el.querySelector('[data-cg-bar]') ? null : el), balk = el.querySelector('[data-cg-bar]');
    var tik = function () {
      var ronde = uren * 3600000, rest = ronde - (Date.now() % ronde);
      var s = Math.floor(rest / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (tijd) tijd.textContent = [h, m, sec].map(function (x) { return String(x).padStart(2, '0'); }).join(':');
      if (balk) balk.style.width = Math.max(4, (rest / ronde) * 100).toFixed(2) + '%';
    };
    tik(); var t = setInterval(tik, 1000);
    el.__cgStop = function () { clearInterval(t); };
  }

  /* ═══ 8. VRAGEN: zacht open en dicht ════════════════════════════════════ */
  function vraag(det) {
    if (det.__cg) return; det.__cg = true;
    var sum = det.querySelector('summary'), body = det.querySelector('[data-cg-answer]');
    if (!sum || !body) return;
    var anim = null, gewenst = det.open, versie = 0;
    sum.addEventListener('click', function (e) {
      if (stil() || !body.animate) return;
      e.preventDefault();
      if (!anim) gewenst = det.open;
      gewenst = !gewenst;
      var token = ++versie;
      var van = det.open ? body.getBoundingClientRect().height : 0;
      if (anim) anim.cancel();
      det.open = true;
      var naar = gewenst ? body.scrollHeight : 0;
      det.classList.toggle('is-closing', !gewenst);
      anim = body.animate([{ height: van + 'px', opacity: gewenst ? 0.3 : 1 }, { height: naar + 'px', opacity: gewenst ? 1 : 0 }], { duration: gewenst ? 340 : 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
      anim.onfinish = function () {
        if (token !== versie) return;
        det.open = gewenst; det.classList.remove('is-closing'); anim = null;
      };
    });
  }

  /* ═══ 9. DE GETEKENDE CIRKEL om het cursieve woord ═════════════════════ */
  var NS = 'http://www.w3.org/2000/svg';
  function cirkel(kop) {
    each(kop.querySelectorAll('em'), function (em) {
      if (em.querySelector('.cg-cirkel__lijn')) return;
      var svg = d.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'cg-cirkel__lijn');
      svg.setAttribute('viewBox', '0 0 200 60');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('aria-hidden', 'true');
      var pad = d.createElementNS(NS, 'path');
      pad.setAttribute('d', 'M112 7C64 3 12 11 7 30c-4 17 44 25 96 23 54-2 93-12 90-29-3-14-44-21-90-19-29 1-55 6-71 13');
      pad.setAttribute('pathLength', '1');
      svg.appendChild(pad);
      em.appendChild(svg);
    });
    if (!kop.hasAttribute('data-cg-reveal')) kop.setAttribute('data-cg-reveal', 'draw');
  }

  /* ═══ 10. VOOR EN NA ═══════════════════════════════════════════════════
     De schuif is een gewone range-input over het hele beeld: slepen met de
     muis of een vinger, en pijltjes met het toetsenbord, werken zonder eigen
     code. Komt hij in beeld, dan beweegt hij één keer heen en weer, zodat je
     ziet dat je kunt slepen (niet bij minder beweging, en niet als iemand hem
     al aanraakte). */
  var voornaIO = null;
  function voornaZet(el, waarde) {
    var v = clamp(parseFloat(waarde) || 0, 0, 100);
    el.style.setProperty('--cg-voorna', v + '%');
    var inp = el.querySelector('.cg-voorna__schuif');
    if (inp && String(inp.value) !== String(Math.round(v))) inp.value = Math.round(v);
    if (inp) inp.setAttribute('aria-valuetext', 'Voor ' + Math.round(v) + '%, na ' + (100 - Math.round(v)) + '%');
  }
  function voornaHint(el) {
    if (el.__cgHint || el.__cgAangeraakt || stil()) return;
    el.__cgHint = true;
    var start = null, duur = 1800, basis = num(el, 'data-cg-voorna-start', 50);
    var stap = function (ts) {
      if (el.__cgAangeraakt) return;
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duur);
      voornaZet(el, basis + Math.sin(t * Math.PI * 2) * 14 * (1 - t * 0.35));
      if (t < 1) requestAnimationFrame(stap); else voornaZet(el, basis);
    };
    setTimeout(function () { requestAnimationFrame(stap); }, 450);
  }
  function voorna(el) {
    if (el.__cg) return; el.__cg = true;
    var inp = el.querySelector('.cg-voorna__schuif');
    if (!inp) {
      inp = d.createElement('input');
      inp.type = 'range'; inp.className = 'cg-voorna__schuif'; inp.min = '0'; inp.max = '100';
      inp.setAttribute('aria-label', el.getAttribute('data-cg-voorna-label') || 'Vergelijk voor en na');
      el.appendChild(inp);
    }
    var raak = function () { el.__cgAangeraakt = true; };
    inp.addEventListener('input', function () { raak(); voornaZet(el, inp.value); });
    inp.addEventListener('pointerdown', raak);
    inp.addEventListener('keydown', raak);
    inp.addEventListener('focus', raak);
    voornaZet(el, num(el, 'data-cg-voorna-start', parseFloat(inp.value) || 50));
    if (voornaIO) voornaIO.observe(el);
  }

  /* ═══ OPZETTEN ═══════════════════════════════════════════════════════════ */
  var aan = false;
  function scan(bereik) {
    bereik = bereik || d;
    each(bereik.querySelectorAll('.cg-cirkel'), cirkel);
    each(bereik.querySelectorAll('[data-cg-reveal="letters"]'), letters);
    each(bereik.querySelectorAll('[data-cg-reveal]'), function (el) {
      if (el.__cgR) return; el.__cgR = true;
      if (!aan) { laatZien(el); return; }
      revIO.observe(el);
    });
    each(bereik.querySelectorAll('[data-cg-scene],[data-cg-progress],[data-cg-parallax]'), function (el) {
      if (el.__cgRun) return;
      var r = el.__cgRun = {
        el: el, scene: el.hasAttribute('data-cg-scene'), prog: el.hasAttribute('data-cg-progress'),
        par: el.hasAttribute('data-cg-parallax') ? num(el, 'data-cg-parallax', 0.12) : 0,
        rot: el.hasAttribute('data-cg-rotate') ? num(el, 'data-cg-rotate', 8) : 0,
      };
      r.meet = (r.par || r.rot) && el.parentElement ? el.parentElement : el;
      lopers.push(r);
      if (actIO) actIO.observe(el); else actief.add(r);
    });
    each(bereik.querySelectorAll('[data-cg-count]'), function (el) {
      if (el.__cgC) return; el.__cgC = true;
      if (!aan || el.getBoundingClientRect().top < w.innerHeight) return;
      var p = delen(el.getAttribute('data-cg-count'));
      if (!p || !(p.doel > 0)) return;
      el.textContent = schrijf(p, 0);
      telIO.observe(el);
    });
    each(bereik.querySelectorAll('[data-cg-carousel]'), carrousel);
    each(bereik.querySelectorAll('[data-cg-slides]'), slides);
    each(bereik.querySelectorAll('[data-cg-ticker]'), ticker);
    each(bereik.querySelectorAll('[data-cg-countdown]'), klok);
    each(bereik.querySelectorAll('details[data-cg-faq]'), vraag);
    each(bereik.querySelectorAll('[data-cg-voorna]'), voorna);
    plan();
  }

  function start() {
    if (aan) return;
    if (!('IntersectionObserver' in w) || stil()) { aan = false; root.classList.remove('cg-motion'); return; }
    aan = true;
    root.classList.add('cg-motion');
    revIO = new IntersectionObserver(bijBinnenkomen, { threshold: [0, 0.12] });
    actIO = new IntersectionObserver(bijActief, { rootMargin: '30% 0px' });
    telIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { telIO.unobserve(e.target); telOp(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
    voornaIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) { voornaIO.unobserve(e.target); voornaHint(e.target); } });
    }, { threshold: [0, 0.5] });
  }

  start();
  w.__cgBeweging = { scan: scan };
  w.addEventListener('scroll', plan, { passive: true });
  var opnieuw = function () { lopers.forEach(function (r) { r.sv = r.qv = r.tf = null; }); plan(); };
  w.addEventListener('resize', opnieuw, { passive: true });
  w.addEventListener('pageshow', opnieuw);
  if (mq.addEventListener) mq.addEventListener('change', function () {
    if (!stil()) { plan(); return; }
    root.classList.remove('cg-motion');
    each(d.querySelectorAll('[data-cg-reveal]'), laatZien);
    lopers.forEach(function (r) { if (r.par || r.rot) { r.el.style.transform = ''; r.tf = null; } });
  });
  d.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target; if (!sec || !sec.querySelectorAll) return;
    [sec].concat(Array.prototype.slice.call(sec.querySelectorAll('*'))).forEach(function (el) {
      if (typeof el.__cgStop === 'function') el.__cgStop();
      if (el.__cgRun) actief.delete(el.__cgRun);
    });
    lopers = lopers.filter(function (r) { return r.el !== sec && !sec.contains(r.el); });
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { scan(d); });
  else scan(d);
  w.addEventListener('load', function () { plan(); });

  // De thema-editor: opnieuw binden na een wijziging, en laten zien wat je bewerkt.
  ['shopify:section:load', 'shopify:section:reorder'].forEach(function (n) {
    d.addEventListener(n, function (e) { setTimeout(function () { scan(e.target || d); }, 0); });
  });
  d.addEventListener('shopify:section:select', function (e) {
    each((e.target || d).querySelectorAll('[data-cg-reveal]'), laatZien);
  });
  // Toetsenbordfocus maakt verborgen inhoud meteen zichtbaar.
  d.addEventListener('focusin', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-cg-reveal]:not(.is-in)') : null;
    if (el) laatZien(el);
  });
})();
